<template>
    <div class="grid">
    <div class="col-12">
        <Card id="toolbar">
            <template #title>
                <Toolbar>
                    <template #right>
                        <div class="p-card-title" style="margin-top:10px;">
                            <Button label="Print" icon="pi pi-print pi-fw" class="p-button-success mr-2" @click="downloadPrint()" />
                            <Button v-if="this.$IS_PRINT_DOCUMENT == 'TRUE'" label="Pdf" icon="pi pi-file-pdf pi-fw" class="p-button-danger mr-2" @click="exportToPDF" />
                            <Button label="Back" icon="pi pi-chevron-left" class="p-button-primary"  @click="backToIndex" />
                        </div>
                    </template>
                </Toolbar>
            </template>
        </Card>
        <div class="surface-0">
            <div id="apps" class="center">
                <table class="table"  ref="document" style="font-family:'Times New Roman', Times, serif;font-size:12px;" v-if="dataDocument">
                    <thead>
                         <tr>
                            <!-- <th rowspan="3" colspan="2" style="width:30%;">
                                 <img src="/assets/layout/images/wilmar-logo.png"  style="float:left;" width="120" height="40"/> 
                            </th> -->
                            <th rowspan="2" colspan="7"> <span class="title">KICK OFF MEETING</span></th>
                            <!-- <td style="text-align:center;width:35%;height:40px;font-size:10px;" colspan="3">
                                 <span v-if="dataDocument"> {{ "FRM-011/PRO-GSK/2022" /*dataDocument.Doc_No*/ }}</span>
                            </td> -->
                            <td style="text-align:center;width:40%;" colspan="3">PROJECT</td>
                        </tr>
                        <!-- <tr style="text-align:center;">
                            <td colspan="3">PROJECT</td>
                        </tr> -->
                       
                        <tr style="text-align:center;">
                           <td colspan="3" rowspan="2"><span style="color:red;" v-if="dataDocument"><b>"{{dataDocument.Project}}"</b></span></td>
                        </tr>

                        <tr>
                            <td colspan="7"><p align="center">MEETING NO : {{ dataDocument != null ? dataDocument.Meeting_No:"" }}</p></td>
                            <!-- <td colspan="3"><p>MEETING NO : {{ dataDocument != null ? dataDocument.Meeting_No:"" }}</p></td> -->
                        </tr>

                        <tr style="height:20px;">
                            <td colspan="7"><p align="center" v-if="dataDocument">SPO NO: {{dataDocument.No_SPO}}</p></td>
                            <td rowspan="2" colspan="3"><p>DATE OF MEETING : {{ dataDocument != null ? this.$formatDate(dataDocument.Date_Of_Meeting):"" }}</p></td>
                        </tr>
                   
                        <tr style="text-align:center;">
                            <td colspan="7"><p>ATTENDED BY</p></td>
                        </tr>
                        <tr style="text-align:center;height:40px;">
                            <td colspan="4">
                                COMPANY : <span v-if="dataDocument" style="color:red;">"{{dataDocument.company}}"</span>
                            </td>
                            <td colspan="3">
                                COMPANY : <span v-if="dataDocument" style="color:red;">"{{dataDocument.contractor}}"</span>
                            </td>
                            <td colspan="3">
                                <p align="left">TIME OF MEETING : {{ dataDocument != null ? this.$formatTime(dataDocument.Date_Of_Meeting):"" }}</p>
                            </td>
                        </tr>

                    </thead>
                    <tbody>
                     
                        <tr style="text-align:center;">
                            <td>NAME</td>
                            <td>DEPT</td>
                            <td>JOB ROLE</td>
                            <td>SIGN</td>
                            <td>NAME</td>
                            <td>JOB ROLE</td>
                            <td>SIGN</td>
                            <td colspan="3">
                                <p align="left">MEETING ROOM : {{ dataDocument != null ? dataDocument.Meeting_Room:"" }}</p>
                            </td>
                        </tr>
                        <tr v-for="(item, i) in companydetail" :key="i" v-if="companydetail.length == 1">
                                <td>{{item.Name}}</td>
                                <td>{{item.Dept}}</td>
                                <td>{{item.JobRole}}</td>
                                <td>{{item.Sign}}</td>
                                <td>{{item.Name1}}</td>
                                <td>{{item.JobRole1}}</td>
                                <td>{{item.Sign1}}</td>
                                <td colspan="3" rowspan="(companydetail.length - 1) + 5" v-if="i==0">
                                    <p align="center">DOCUMENTATION </p>
                                </td>
                        </tr>
                        <tr v-for="(item, k) in companydetail" :key="k" v-else-if="companydetail.length > 1">
                            <td>{{item.Name}}</td>
                            <td>{{item.Dept}}</td>
                            <td>{{item.JobRole}}</td>
                            <td>{{item.Sign}}</td>
                            <td>{{item.Name1}}</td>
                            <td>{{item.JobRole1}}</td>
                            <td>{{item.Sign1}}</td>
                            <td colspan="3" v-if="k==0">
                                <p align="center">DOCUMENTATION </p>
                            </td>
                            <td colspan="3" :rowspan="(companydetail.length - 1) + array2.length" v-if="k==1" style="text-align:center;">
                                <img :src="imgdocumentation" style="width:200px;"/>
                            </td>
                        </tr>
                        <tr v-for="(item,i) in array2" :key="i" style="height:15px;">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td v-if="companydetail.length == 1"></td>
                            <td colspan="3" v-if="companydetail.length == 1 && i==0" :rowspan="array2.length" style="text-align:center;">
                                <img :src="imgdocumentation" style="width:200px;"/>
                            </td>
                            <td v-else-if="companydetail.length > 1">

                            </td>
                        </tr>
              
                        <tr style="height: 50px;text-align:center;">
                            <td colspan="2">{{ dataDocument != null ? dataDocument.Notes_Issued_By:"" }}</td>
                            <td rowspan="2" style="background-color:rgb(200, 200, 200);"></td>
                            <td colspan="2"> {{ dataDocument != null ? dataDocument.Approved_By:"" }} </td>
                            <td colspan="2" rowspan="2" style="background-color:rgb(200, 200, 200);"></td>
                            <td style="width:15%"> {{ dataDocument != null ? this.$formatDate(dataDocument.Issued_Date):"" }} </td>
                            <td colspan="2" rowspan="2" style="background-color:rgb(200, 200, 200);"></td>
                        </tr>
                        <tr style="text-align:center;">
                            <td colspan="2">NOTES ISSUED BY</td>
                            <td colspan="2">APPROVED BY</td>
                            <td>ISSUED DATE</td>
                        </tr>
                        <tr style="text-align:center;font-weight:bold;">
                            <td>ITEM</td>
                            <td colspan="6">DESCRIPTION OF DISCUSSIONS</td>
                            <td>ACTION BY</td>
                            <td>DATE OF ACTION REQUIRED</td>
                            <td>REMARK</td>
                        </tr>
                        <tr v-if="dataDocument" v-for="(item, i) in dataDocument.Items" :key="item.Id" style="text-align:center;height:15px;" 
                        :class="{'pagebreak' : (arrindex.length > 100 &&  (i) == 0)  || i+1 == 23 || arrindex.length < 100 && arrindex1.includes(i+1)}">
                            <td>
                                <span v-if="item.Description_Discussions !=null">{{i+1}}</span>
                            </td>
                            <td colspan="6" style="text-align:left;">{{item.Description_Discussions}}</td>
                            <td>{{item.Action_By}}</td>
                            <td>{{this.$formatDate(item.Date_Action_Required)}}</td>
                            <td>{{item.Remark}}</td>
                        </tr>
                        <!-- <tr v-for="(item,i) in array1" :key="i" style="height:15px;text-align:center;">
                            <td>
                              
                            </td>
                            <td colspan="6"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr> -->
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="5" style="border:none;" class="tdfoot">
                                <img src="/assets/layout/images/stamp-draft.png" height="120" width="140" v-if="dataDocument.Status == this.$REQUEST_STATUS.DRAFT|| dataDocument.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || dataDocument.Status == this.$APPROVAL_STATUS.REVISED"/>
                            </td>
                            <td colspan="5" style="border:none;" class="tdfoot">
                                <VueQrcode :value="valueLink" style="width:85px;float:right;"></VueQrcode>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="10" v-if="dataDocument.Status == this.$APPROVAL_STATUS.DONE" style="border:none;">
                                <p style="margin-top:-10px;font-size:11px;">
                                    <b>
                                        {{ 
                                            this.signBy(dataDocument)
                                        
                                        }}

                                    </b>
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 10px;">
                            <td style="border: none;"></td>
                        </tr>
                    </tfoot>
                </table>
            </div> 
        </div>
</div>
</div>

</template>

<script>
import html2pdf from 'html2pdf.js'

export default{
data(){
    return {

        listDoc : null,
        dataheader : null,
        title : "listdocuments",
        docvalidity : [],
        type :this.$TypeDocument.BA_IK_WITH_SPO,
        compCode : "",
        dataDocument:null,
        imgdocumentation : "",
        companydetail : null,
        array1 : [1,2,3,4,5,6,7,8,9,10],
        array2 : [1,2,3,4,5],
        valueLink :this.$store.getters.getUrlApp + this.$route.fullPath,
        arrindex1 : [],
        arrindex : []
    }
},
methods:{
    signBy(data){
        this.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())})`; 
        return this.signby;
    },  
    backToIndex(){
        if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
        else 
            this.$router.push({ path: "/DocKom/Index" });
    },
    downloadPrint(){
        this.$emit('block-ui');
            var self = this;
                const link = this.valueLink;
                //var qr = document.getElementById('qr').src;
                //const [mimeType, base64Data] = dataURL.split(';base64,');
                this.$axios.get(this.$API_URL + "DocKom/" + "exportprint", {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG,
                params : {
                    id : this.$route.query.id,
                    linqr : link,
                    company : this.dataDocument.company,
                    contractor : this.dataDocument.contractor,
                    signby : this.signby,
                }  
                })
                .then((response) => {
                    //const url = window.URL.createObjectURL(new Blob([response.data]));
                    let fileName = response.headers["content-disposition"].split("filename=")[1].split(";")[0];

                    const blob = new Blob([response.data], { type: 'application/pdf' });

                    // Create an object URL from the Blob
                    const url = URL.createObjectURL(blob);
                    // Set the iframe src attribute to the object URL
                    window.open(url, '_blank');
                    //this.$refs.pdfPreview.src = url;
                    // const link = document.createElement('a');
                    // link.href = url;
                    // link.setAttribute('download', fileName);
                    // document.body.appendChild(link);
                    // link.click();
                    self.$emit('unblock-ui');
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    self.$emit('unblock-ui');
                    //self.showAssignModal = false;
                });
    },
    printWindow() {
        this.addPagenumber();
        window.print();
        this.removePageNumbers();
    },
    addPagenumber(){
        let pageNumber = 1;
        var table = this.$refs.document;
        var scrollHeight = table.offsetHeight;
        var totalPages = Math.round(scrollHeight / window.outerHeight);
        for (let i = 0; i < totalPages; i++) {
            var pageNumberDiv = document.createElement("div");
            var pgNum = document.createTextNode("" + (i+1) + "/" + totalPages);
            pageNumberDiv.classList.add('page-number');
            pageNumberDiv.style.position = "absolute";
            if(i != 0){
                pageNumberDiv.style.top = "calc((281mm - (0.5px + " + (i+1) +"px)) * " + (i+1)+ " - 29px)";
            }else{
                pageNumberDiv.style.top = "calc((285mm - 0.5px) * " + (i+1)+ " - 40px)";
            }
            pageNumberDiv.style.right = 0;
            pageNumberDiv.style.height = "12px";
            pageNumberDiv.appendChild(pgNum);
            document.body.appendChild(pageNumberDiv);
            
        }
    },
    removePageNumbers() {
        const pageNumberElements = document.querySelectorAll('.page-number');
        pageNumberElements.forEach(element => element.remove());
    },

    exportToPDF() {
        
        html2pdf(this.$refs.document, {
            margin: 10,
            filename: 'myfile.pdf',
            image: { type: 'jpeg', quality: 1},
            html2canvas: { scale: 4},
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },

        })
    },
    getData() {
            this.$emit('block-ui');
            let self = this;
            self.$axios.get(this.$API_URL + "DocKom/getDataDoc/"+ this.$route.query.id 
            ).then((response) => {
                var data = response.data.data;
                self.dataDocument = data.document;
                self.imgdocumentation = data.imgdocumentation;
                self.companydetail = data.companydetail;

                self.companydetail.forEach((a,i) => {
                    self.arrindex.push(i + 1)
                });
               
                self.dataDocument.Items.forEach((b,i)=>{
                    self.arrindex1.push(71 + (i * 48))
                });

                
                for(var i =0; i <= 10;i++){
                    const myObject = { Remark: ''};
                    self.dataDocument.Items.push(myObject)
                }

                self.$emit('unblock-ui');
            
            }).catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 6000 });
                    self.$emit('unblock-ui');
            });
        },
    },
    computed:{
    },   
    created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;
            this.getData();
        },
}
</script>
<style>
@page {
    size: A4 portrait;
    margin: 9mm;
}
@media print {
    #app .layout-wrapper .p-blockui-container .layout-topbar{
        display: none;
    }

    #app .layout-wrapper .p-blockui-container .layout-sidebar{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-footer{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-main-container{
        padding: 10px;
        margin: 0;
     }

    @page { size: portrait; }
}
@media screen and (max-width: 64em) {
    .p-sidebar-left.p-sidebar-lg,
    .p-sidebar-left.p-sidebar-md,
    .p-sidebar-right.p-sidebar-lg,
    .p-sidebar-right.p-sidebar-md {
        width: 20rem;
    }
}
#apps{
    width: 80%;
}

</style>
<style scoped>
@media print {
    tfoot {
      position: fixed;
      bottom: 0;
      width: 100%;  
    }
    .tdfoot{
        width: 100%;
    }
    
    #toolbar{
        display: none;
    }
    #display{
        display: none;
    }

    body{
      width: 100%;
      margin: 0 auto;
    }

    #apps{
        width: 100%;
        margin-top: -5px;
    }

}
.table {
    border-collapse: collapse;
    width: 100%;
    color: black;
    word-break:break-all;
}
.table .th {
    padding-top: 12px;
    padding-bottom: 12px;
}
  /* #f9f340*/
.table .center{
    text-align: center;
}
.table td, .table th {
    border: 1px solid black;
}

.ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 12px;
    margin-top:-10px;
}

hr{
    border-top: 1.5px dotted black;
    padding: 0.3px;
    border-bottom: 1.8px solid black;
    margin : 0 auto;
    width:110px;
   }



#toolbar{
    max-height: 90px;
}

.title{
    font-size: 20px;
}
.year{
    margin-left: 290px;
}
.center{
    margin: auto;
}
.p1 {
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
    white-space: normal;
    font-size:14px;
  }
  .widht1{
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
  }
  
  .pagebreak{
        page-break-after: always;
    }
</style>